import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { FiWrapperTableCellBase } from '@fi-shared/fi-wrapper-table/cells/fi-wrapper-table-cell-base';
import { FiDateFormatOptions } from '@fi-shared/utils';
import { SharedActionsBaseService } from '@fi-shared/fi-shared-services/shared-actions-base.service';
import { IDateByItem } from '@fi-shared/models/models';
import { AppTextService } from '@fi-shared/app-text';

@Component({
    selector: 'fi-wrapper-table-date-by-user-id-cell',
    template: `
        @if (!!value) {
            <fi-wrapper-table-span-cell [value]="value.Date | fiFormatDate: fiDateFormatRegistry" />
            @if (value.ItemProfile) {
                @let systemUser = isSystemUser();
                @let userName = getUserName();
                <fi-wrapper-table-span-cell
                    class="additional-text"
                    [class.BrandedColorHover]="!systemUser"
                    [class.cursor-pointer]="!systemUser"
                    [value]="userName"
                    (click)="openUserViewDialog($event, systemUser)"
                />
            }
        }
    `,
    styleUrl: './fi-wrapper-table-date-by-user-id-cell.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-wrapper-table-date-by-user-id-cell' },
    standalone: false,
})
export class FiWrapperTableDateByUserIdCellComponent extends FiWrapperTableCellBase<IDateByItem> {
    @Input() fiDateFormatRegistry: Intl.DateTimeFormatOptions = FiDateFormatOptions;
    @Input() systemUserNameTextId: string = 'common.system';

    constructor(
        private sharedActionsService: SharedActionsBaseService,
        private appTextService: AppTextService,
    ) {
        super();
    }

    protected getUserName(): string {
        return this.isSystemUser()
            ? this.appTextService.get(this.systemUserNameTextId)
            : this.value.ItemProfile.FullName;
    }

    protected isSystemUser(): boolean {
        return this.value.ItemProfile.Id === 0;
    }

    protected openUserViewDialog($event: MouseEvent, isSystemUser: boolean): void {
        $event.stopPropagation();
        if (isSystemUser) {
            return;
        }
        this.sharedActionsService.openUserViewPopup(this.value.ItemProfile.Id);
    }
}
